export {ErrorDialogController, ErrorDialogEvents} from './ErrorDialog.controller';
export {ErrorDialog} from './ErrorDialog.component';
